import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class SLAService extends CrudService {
  constructor() {
    super('SLAs')
  }

  uploadSLA = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }
}

export default SLAService
